









































import CompanySheet from "@/components/company/CompanySheet.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ICompany } from "@/models/company.entity";
import { PartnerModule } from "@/store/modules/partner";
import CompanyMapDialog from "@/views/company/CompanyMapDialog.vue";
import { mixins } from "vue-class-component";
import { Component, Watch } from "vue-property-decorator";
import CompanySelection from "../contact/CompanySelection.vue";

@Component({
  components: {
    MIconButton,
    MNoContent,
    CompanyMapDialog,
    CompanySheet,
    CompanySelection,
    ConfirmActionDialog
  },
  filters: {}
})
export default class PartnerReportSelectAppraiserCard extends mixins(PermissionMixin) {
  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get vehicleLocationString(): string {
    const location = this.report.location || {};
    const parts = [];

    if (location.street) {
      parts.push(location.street);
    }

    const zipCity = [location.zip, location.city].filter(Boolean).join(" ");
    if (zipCity) {
      parts.push(zipCity);
    }

    return parts.join(", ");
  }

  isUpdatingReport = false;
  selectAppraiserDialog = false;
  filter = CompanyServiceEnum.APPRAISER;

  localAppraiserCompany: ICompany | null = null;

  get appraiserCompanyId() {
    return this.report.appraiserCompanyId;
  }

  get selectAppraiserIcon() {
    if (this.appraiserCompanyId) {
      return "mdi-pencil-outline";
    }
    return "mdi-plus";
  }

  openDialog() {
    if (this.report.appraiserCompany) {
      this.localAppraiserCompany = this.report.appraiserCompany;
    } else {
      this.localAppraiserCompany = null;
    }

    this.selectAppraiserDialog = true;
  }

  async selectAppraiser() {
    this.isUpdatingReport = true;

    (await this.report
      .updatePartial({ appraiserCompanyId: this.localAppraiserCompany?.id || null })
      .catch(error => handleError(error))) || null;
    await this.fetchAppraiser();

    this.isUpdatingReport = false;

    this.selectAppraiserDialog = false;
  }

  @Watch("report", { immediate: true })
  onReportChanged() {
    if (this.report?.appraiserCompanyId) {
      this.fetchAppraiser();
    }
  }

  private async fetchAppraiser() {
    await this.report.fetchAppraiserEntity().catch(handleError);
  }
}
